import { render, staticRenderFns } from "./editDocument.vue?vue&type=template&id=5d66d132&scoped=true&lang=html&"
import script from "./editDocument.vue?vue&type=script&lang=js&"
export * from "./editDocument.vue?vue&type=script&lang=js&"
import style0 from "./editDocument.vue?vue&type=style&index=0&id=5d66d132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66d132",
  null
  
)

export default component.exports